import * as colors from './baseColors';

export interface PaletteColors {
  appleDarker: string;
  appleDark: string;
  appleBase: string;
  appleLight: string;
  appleLighter: string;

  blazeDarker: string;
  blazeDark: string;
  blazeBase: string;
  blazeLight: string;
  blazeLighter: string;

  chimneyLightest: string;
  chimneyLighter: string;
  chimneyLight: string;
  chimneyBase: string;
  chimneyDark: string;
  chimneyDarker: string;
  chimneyDarkest: string;

  emeraldLighter: string;
  emeraldLight: string;
  emeraldBase: string;
  emeraldDark: string;
  emeraldDarker: string;

  grayLight: string;
  grayBase: string;
  grayDark: string;
  grayDarker: string;

  lilacDarker: string;
  lilacDark: string;
  lilacBase: string;
  lilacLight: string;
  lilacLighter: string;

  royalLighter: string;
  royalLight: string;
  royalBase: string;
  royalDark: string;
  royalDarker: string;

  slateDarker: string;
  slateDark: string;
  slateBase: string;
  slateLight: string;
  slateLighter: string;

  sunglowDarker: string;
  sunglowDark: string;
  sunglowBase: string;
  sunglowLight: string;
  sunglowLighter: string;

  watermelonDarker: string;
  watermelonDark: string;
  watermelonBase: string;
  watermelonLight: string;
  watermelonLighter: string;
}

// Color Palettes, these raw values do not change with light/dark modes
export const paletteColors: PaletteColors = {
  appleDarker: colors.appleDarker,
  appleDark: colors.appleDark,
  appleBase: colors.appleBase,
  appleLight: colors.appleLight,
  appleLighter: colors.appleLighter,

  blazeDarker: colors.blazeDarker,
  blazeDark: colors.blazeDark,
  blazeBase: colors.blazeBase,
  blazeLight: colors.blazeLight,
  blazeLighter: colors.blazeLighter,

  chimneyLightest: colors.chimneyLightest,
  chimneyLighter: colors.chimneyLighter,
  chimneyLight: colors.chimneyLight,
  chimneyBase: colors.chimneyBase,
  chimneyDark: colors.chimneyDark,
  chimneyDarker: colors.chimneyDarker,
  chimneyDarkest: colors.chimneyDarkest,

  emeraldLighter: colors.emeraldLighter,
  emeraldLight: colors.emeraldLight,
  emeraldBase: colors.emeraldBase,
  emeraldDark: colors.emeraldDark,
  emeraldDarker: colors.emeraldDarker,

  grayLight: colors.grayLight,
  grayBase: colors.grayBase,
  grayDark: colors.grayDark,
  grayDarker: colors.grayDarker,

  lilacDarker: colors.lilacDarker,
  lilacDark: colors.lilacDark,
  lilacBase: colors.lilacBase,
  lilacLight: colors.lilacLight,
  lilacLighter: colors.lilacLighter,

  royalBase: colors.royalBase,
  royalDark: colors.royalDark,
  royalDarker: colors.royalDarker,
  royalLight: colors.royalLight,
  royalLighter: colors.royalLighter,

  slateDarker: colors.slateDarker,
  slateDark: colors.slateDark,
  slateBase: colors.slateBase,
  slateLight: colors.slateLight,
  slateLighter: colors.slateLighter,

  sunglowDarker: colors.sunglowDarker,
  sunglowDark: colors.sunglowDark,
  sunglowBase: colors.sunglowBase,
  sunglowLight: colors.sunglowLight,
  sunglowLighter: colors.sunglowLighter,

  watermelonDarker: colors.watermelonDarker,
  watermelonDark: colors.watermelonDark,
  watermelonBase: colors.watermelonBase,
  watermelonLight: colors.watermelonLight,
  watermelonLighter: colors.watermelonLighter,
};
